import { render, staticRenderFns } from "./Positive.vue?vue&type=template&id=66c2dbe1&"
import script from "./Positive.vue?vue&type=script&lang=ts&"
export * from "./Positive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports